class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.closeButton = this.querySelector('[type="button"]');
    this.overlay = this.querySelector('.modal-overlay');

    if (!this.details || !this.summary) return;

    this.onToggle = this.onToggle.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    this.details.addEventListener('toggle', this.onToggle);

    if (this.closeButton) this.closeButton.addEventListener('click', this.onClose);
    if (this.overlay) this.overlay.addEventListener('click', this.onClose);
    this.addEventListener('keyup', this.onKeyUp);
  }

  onToggle() {
    if (this.details.open) {
      document.body.classList.add('overflow-hidden');
      const focusTarget = this.querySelector('input, button, textarea, select, a[href]');
      if (focusTarget) focusTarget.focus();
      return;
    }

    document.body.classList.remove('overflow-hidden');
    this.summary.focus();
  }

  onClose() {
    this.details.removeAttribute('open');
  }

  onKeyUp(event) {
    if (event.code === 'Escape') {
      this.onClose();
    }
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
